import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Assessment } from '../../../../../models/assessment';
import { RiskBand } from '../../../../../models/risk-band';

@Component({
  selector: 'lib-risk-assessment-survey-details-modal',
  templateUrl: './risk-assessment-survey-details-modal.component.html',
  styleUrls: ['./risk-assessment-survey-details-modal.component.scss']
})
export class RiskAssessmentSurveyDetailsModalComponent {
  public assessment: Assessment = new Assessment();

  constructor(private dynamicDialogRef: DynamicDialogRef,
              private dynamicDialogConfig: DynamicDialogConfig) {
    this.assessment = this.dynamicDialogConfig?.data?.assessment;
  }

  close(): void {
    this.dynamicDialogRef.close();
  }

  getRiskBandRange(riskBand: RiskBand, index: number): string {
    if (index === 0 || !index) {
      // minimum lower limit is always 0
      // 1st one
      return '0 - ' + riskBand.numericValue;
    } else {
      // the rest of 'em
      return this.assessment?.riskBands[index - 1]?.numericValue + ' - ' + riskBand.numericValue;
    }
  }
}
